export const zh = {
  // Navigation
  'nav.search.placeholder': '搜索帖子、招聘、问题...',
  'nav.anonymous.mode': '[匿名模式]',
  
  // Sidebar Menu
  'menu.feed': '动态',
  'menu.jobs': '招聘',
  'menu.study': '学习',
  'menu.knowledge': '知识',
  'menu.learning': '学习网站',
  'menu.premium': '高级会员',
  'menu.news': '新闻',
  'menu.bugbounty': '漏洞赏金',
  
  // Feed Tab
  'feed.title': '实时动态',
  'feed.new.post': '+ 新帖子',
  'feed.category.all': '全部',
  'feed.category.vulnerability': '漏洞',
  'feed.category.study': '学习',
  'feed.category.job': '招聘',
  'feed.category.knowledge': '知识',
  'feed.replies': '回复',
  'feed.likes': '点赞',
  
  // Jobs Tab
  'jobs.title': '招聘板',
  'jobs.post.job': '+ 发布招聘',
  'jobs.salary': '薪资',
  'jobs.location': '地点',
  'jobs.experience': '经验',
  'jobs.apply.now': '[立即申请]',
  
  // Study Tab
  'study.title': '学习问答',
  'study.ask.question': '+ 提问',
  'study.answers': '回答',
  'study.views': '浏览',
  'study.solved': '✓ 已解决',
  
  // Knowledge Tab
  'knowledge.title': '黑客知识',
  'knowledge.subtitle': '实时黑客知识问答 - 悬赏系统',
  'knowledge.ask.bounty': '+ 悬赏提问',
  'knowledge.answered': '✓ 已回答',
  'knowledge.pending': '⏱ 待处理',
  'knowledge.points': '积分',
  
  // Learning Tab
  'learning.title': '学习网站',
  'learning.subtitle': '精选黑客学习平台合集',
  'learning.difficulty': '难度',
  'learning.users': '用户',
  
  // Premium Tab
  'premium.title': '高级档案',
  'premium.subtitle': '真实黑客试错档案 - 仅限高级会员',
  'premium.only': '仅限高级会员',
  'premium.exclusive': '高级会员专属内容',
  'premium.cases': '案例',
  'premium.membership': '高级会员',
  'premium.description': '无限访问真实黑客试错档案、专家1对1指导、高级学习小组等所有高级内容',
  'premium.price': '¥699 / 月',
  'premium.upgrade.now': '[立即升级]',
  'premium.modal.title': '需要高级会员',
  'premium.modal.description': '此内容仅限高级会员访问。获取真实黑客试错档案和所有高级功能的访问权限。',
  'premium.modal.upgrade': '[升级到高级会员]',
  'premium.modal.close': '[关闭]',
  
  // Sidebar Stats
  'stats.title': '// 实时统计',
  'stats.online.hackers': '在线黑客',
  'stats.today.posts': '今日帖子',
  'stats.active.threads': '活跃主题',
  'stats.trending.tags': '// 热门标签',
  'stats.top.hackers': '// 顶级黑客',
  
  // Time
  'time.minutes.ago': '分钟前',
  'time.hour.ago': '小时前',
  'time.hours.ago': '小时前',
  'time.realtime': '实时',

  // Search
  'search.input.placeholder': '搜索帖子、招聘、问题...',
  'search.tab.all': '全部',
  'search.tab.feed': '动态',
  'search.tab.jobs': '招聘',
  'search.tab.study': '学习',
  'search.tab.knowledge': '知识',
  'search.trending': '热门标签',
  'search.popular': '热门帖子',
  'search.results.count': '个搜索结果',
  'search.sort.relevance': '相关度',
  'search.sort.latest': '最新',
  'search.sort.popular': '热门',
  'search.no.results': '未找到结果',
  'search.no.results.hint': '尝试不同的关键词',
  'search.just.now': '刚刚',
  'search.type.feed': '动态',
  'search.type.job': '招聘',
  'search.type.study': '学习',
  'search.type.knowledge': '知识',

  // Notifications
  'notifications.title': '通知',
  'notifications.all': '全部',
  'notifications.unread': '未读',
  'notifications.mark.all.read': '全部标为已读',
  'notifications.no.unread': '没有未读通知',
  'notifications.no.notifications': '没有通知',
  'notifications.new': '新',
  'notifications.delete': '删除',

  // News Tab
  'news.title': '黑客新闻',
  'news.subtitle': 'Hacker News & 社区安全新闻',
  'news.share.news': '+ 分享新闻',
  'news.category.all': '全部',
  'news.category.vulnerability': '漏洞',
  'news.category.breach': '数据泄露',
  'news.category.malware': '恶意软件',
  'news.category.bounty': '漏洞赏金',
  'news.community': '社区',
  'bugbounty': {
    title: '漏洞赏金区',
    subtitle: '探索全球漏洞赏金计划和最新漏洞报告',
    platforms: {
      title: '漏洞赏金平台',
    },
    writeups: {
      title: '最近公开的Writeup',
    },
    tips: {
      title: '漏洞赏金入门指南',
      start: {
        title: '从小处开始',
        description: '首先从难度较低的项目开始。练习查找XSS、IDOR、CSRF等基本漏洞，然后逐步扩展到更复杂的漏洞。',
      },
      tools: {
        title: '掌握必备工具',
        description: '学习Burp Suite、OWASP ZAP、Nuclei、ffuf、SQLMap等工具。结合自动化工具和手动测试可以发现更多漏洞。',
      },
      report: {
        title: '撰写清晰报告',
        description: '发现漏洞后，清楚地记录重现步骤、影响和PoC。好的报告会带来更快的验证和更高的奖励。',
      },
      community: {
        title: '加入社区',
        description: '参与Twitter、Discord、Reddit上的漏洞赏金社区。阅读其他猎人的writeup，学习最新趋势和技术。',
      },
    },
  },
};

export default zh;
